export default "__VITE_ASSET__eb23e348__"